import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="modal--open"
export default class extends Controller {
  modal!: Modal

  connect() {
    this.modal = Modal.getOrCreateInstance(this.element)

    if (!this.element.classList.contains("show")) {
      this.modal.show()
    }
  }

  disconnect() {
    this.modal?.hide()
  }
}
